import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["domainInput", "submit"]

  check(evt){
    const validDomainRegex = /^([^.]+\.)+[^.]+$/
    // ignore leading @
    let value = this.domainInputTarget.value
    if(value[0] === "@") value = value.substring(1)
    if(value.match(validDomainRegex)) {
      this.submitTarget.disabled = false
    } else {
      this.submitTarget.disabled = true
    }
  }
}
